import { render, staticRenderFns } from "./LoanInfoCard.vue?vue&type=template&id=5455ded6&scoped=true"
import script from "./LoanInfoCard.vue?vue&type=script&lang=js"
export * from "./LoanInfoCard.vue?vue&type=script&lang=js"
import style0 from "./LoanInfoCard.vue?vue&type=style&index=0&id=5455ded6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455ded6",
  null
  
)

export default component.exports